import { CreateAccrualDto } from "../../../dtos/catalogs/accrual/CreateAccrualDto";
import { AccrualDetail } from "../../../components/Pages/Catalogs/Accrual/AccrualDetail";
import { AccrualService } from "../../../services/catalogs/AccrualService";
import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupAccrual } from "../../../components/Shared/NewForms/NFLookupAccrual";
import AccrualList from "../../../components/Pages/Catalogs/Accrual/AccrualList";

export const Accrual: IAppEntity = {
  entityType: "catalog",
  title: "Accrual",
  pluralTitle: "Accrual",
  apiUrl: "Accruals",
  apiEnum: ReferenceTypes.CatalogAccrual,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(AccrualDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(AccrualList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupAccrual, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new AccrualService(this.apiUrl);
  },
  getEmptyModel(): CreateAccrualDto {
    return {
      name: "",
      description: "",
      incomeType: 0,
    };
  },
};
